/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarSeasonTireDtoFromJSON, CarSeasonTireDtoToJSON, } from './';
export function CarTireSectionDtoFromJSON(json) {
    return CarTireSectionDtoFromJSONTyped(json, false);
}
export function CarTireSectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'tireNotes': !exists(json, 'tireNotes') ? undefined : json['tireNotes'],
        'winterTires': !exists(json, 'winterTires') ? undefined : CarSeasonTireDtoFromJSON(json['winterTires']),
        'summerTires': !exists(json, 'summerTires') ? undefined : CarSeasonTireDtoFromJSON(json['summerTires']),
        'allseasonTires': !exists(json, 'allseasonTires') ? undefined : CarSeasonTireDtoFromJSON(json['allseasonTires']),
    };
}
export function CarTireSectionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carId': value.carId,
        'tireNotes': value.tireNotes,
        'winterTires': CarSeasonTireDtoToJSON(value.winterTires),
        'summerTires': CarSeasonTireDtoToJSON(value.summerTires),
        'allseasonTires': CarSeasonTireDtoToJSON(value.allseasonTires),
    };
}
